import React from "react";
import { PolicyDesktop } from "./Policy-desktop";

export const Policy = () => {
  return <PolicyDesktop />;
};
